import { render, staticRenderFns } from "./InsFooterSwiper.vue?vue&type=template&id=4b0c9307&scoped=true&"
import script from "./InsFooterSwiper.vue?vue&type=script&lang=ts&"
export * from "./InsFooterSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./InsFooterSwiper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c9307",
  null
  
)

export default component.exports